import createReducer, { actions } from "../../BasicReducer";
import * as types from "../actions/actionTypes";

const reducer = createReducer('aggregations', {});

export default function aggregations(state, _action = {}) {
  let action = _action;
  if (action.type === types.INITIALIZE_FILTERS_FORM) {
    action = actions.set('aggregations', action.aggregations);
  }

  return reducer(state, action);
}